import { render, staticRenderFns } from "./PreviewReport8.vue?vue&type=template&id=1806d50e&scoped=true"
import script from "./PreviewReport8.vue?vue&type=script&lang=js"
export * from "./PreviewReport8.vue?vue&type=script&lang=js"
import style0 from "./PreviewReport8.vue?vue&type=style&index=0&id=1806d50e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1806d50e",
  null
  
)

export default component.exports